(ns machtfit.repository.search-facets
  (:require [machtfit.api :as api]
            [re-frame.core :as rf])
  (:require-macros [reagent.ratom :refer [reaction]]))

(def ^:private db-path
  [:startpage :search-facets])

(defn facets [db]
  (get-in db db-path))

(defn pending-for? [db location]
  ;; A response for a location the user has since left would otherwise replace
  ;; the current one, and ``::data`` only auto-fetches when the slot is empty, so
  ;; the filter bar would keep describing the old origin.
  (= location (:location (facets db))))

;; The endpoint budgets 60 requests per minute per user and a catalogue
;; navigation is as frequent as a debounced keystroke, so an unbounded retry
;; turns one transient failure into rate-limited degradation that outlives the
;; fault. Three attempts per location, then quiet until the location changes.
(def max-attempts 3)

(defn store-fx [db location result on-landed]
  (if (pending-for? db location)
    (cond-> {:db (assoc-in db db-path
                           (merge {:status :done :location location}
                                  (select-keys result
                                               [:categories-by-area
                                                :online-count
                                                :distance-buckets])))}
      on-landed (assoc :fx [[:dispatch on-landed]]))
    {:db db}))

(rf/reg-event-fx ::store
  (fn [{:keys [db]} [_ location result on-landed]]
    (store-fx db location result on-landed)))

(defn fail-db [db location]
  (if (pending-for? db location)
    (assoc-in db db-path {:status :failed
                          :location location
                          :attempts (inc (:attempts (facets db) 0))})
    db))

(rf/reg-event-db ::fail
  (fn [db [_ location]]
    (fail-db db location)))

(defn fetched? [db location]
  (let [{:keys [status attempts] :as stored} (facets db)]
    (and (= location (:location stored))
         (or (#{:done :pending} status)
             (and (= :failed status) (>= (or attempts 0) max-attempts))))))

(rf/reg-event-fx ::fetch
  (fn [{:keys [db]} [_ on-landed]]
    (let [location (get-in db [:products-location :coordinates])
          stored (facets db)
          attempts (if (= location (:location stored)) (:attempts stored 0) 0)]
      (if (or (nil? location) (fetched? db location))
        {}
        {:db (assoc-in db db-path
                       {:status :pending :location location :attempts attempts})
         ;; ``bare-request``, not ``request``: a failure degrades the filter bar
         ;; rather than replacing the page with the global error screen. There is
         ;; nothing to fall back to -- the catalogue these widgets were derived
         ;; from before the cutover is never fetched on this path -- so they go
         ;; quiet once the attempts are spent.
         :post (api/bare-request db
                                 {:data `[(:search-facets {:origin ~location} :search-facets)]
                                  :on-error #(rf/dispatch [::fail location])
                                  :on-success
                                  (fn [response]
                                    (let [payload (-> response :result :search-facets)]
                                      (if (:success payload)
                                        (rf/dispatch [::store location (:result payload) on-landed])
                                        (rf/dispatch [::fail location]))))})}))))

(rf/reg-sub-raw ::data
  (fn [_ _]
    (reaction
     (let [stored @(rf/subscribe [:get db-path])]
       (when-not stored
         (rf/dispatch [::fetch]))
       stored))))
